import React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  padding?: boolean;
  id?: string;
}

export const Card: React.FC<CardProps> = ({ children, className = '', padding = true, id }) => (
  <div id={id} className={`intrlock-card bg-white rounded-xl border border-gray-100 shadow-lg hover:shadow-xl transition-shadow ${padding ? 'p-6' : ''} ${className}`}>
    {children}
  </div>
);

export const CardHeader: React.FC<{ title: string; subtitle?: string; action?: React.ReactNode }> = ({ title, subtitle, action }) => (
  <div className="intrlock-card-header flex items-center justify-between mb-4">
    <div>
      <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
      {subtitle && <p className="text-sm text-gray-500 mt-0.5">{subtitle}</p>}
    </div>
    {action}
  </div>
);
